import { Coalition } from '@/lib/types/unit';

/**
 * Map coalition tokens from NDF across game patches. Newer WARNO dumps use
 * `TWargameCoalition/PACT`; older ones used `ECoalition/PACT`. Earlier we only
 * recognized the latter, so unknown strings incorrectly defaulted to NATO.
 */
export function coalitionFromRawGameString(
  raw: string | undefined | null
): Coalition | undefined {
  if (raw === undefined || raw === null || raw === '') return undefined;
  const c = raw.replace(/'/g, '').trim();
  const upper = c.toUpperCase();
  if (upper.endsWith('/PACT') || upper === 'PACT') return Coalition.PACT;
  if (upper.endsWith('/NATO') || upper === 'NATO') return Coalition.NATO;
  return undefined;
}

/** Same as coalitionFromRawGameString but falls back to NATO (prior parser behavior). */
export function coalitionFromRawGameStringWithDefault(
  raw: string | undefined | null
): Coalition {
  return coalitionFromRawGameString(raw) ?? Coalition.NATO;
}
